module.exports = __webpack_public_path__ + "static/media/nel.cc9172af.svg";